export const testimonialsTextContent = {
  headingText: (
    <>
      <span>Delivering Slot Excellence.</span>{" "}
      <span>Trusted by Leaders Around the Globe</span>
    </>
  ),
  content: [
    {
      profileImageSrc: "/assets/stock-img/testimonial_img_01.webp",
      profileNameText: "Jeffy Wan",
      profileDesignationText: "Co-Founder & CEO",
      paraText: "“We had an excellent experience with GammaSlots. They listened to our ideas and delivered the slot games just like we wanted. Their teams also made valuable suggestions that helped us make critical improvements in the games. I would recommend them to anyone seeking top-notch slot games.”",
    },
    {
      profileImageSrc: "/assets/stock-img/testimonial_img_02.webp",
      profileNameText: "Maria Janeson",
      profileDesignationText: "CEO",
      paraText: "“We wanted to launch our slot game quickly and the teams from GammaSlots helped us in multiple areas. Their teams are highly professional and they also shared their insights to help us understand our target customers better. We are very happy with the slot games they have delivered. We’ll be working with them again soon.”",
    },
    {
      profileImageSrc: "/assets/stock-img/testimonial_img_01.webp",
      profileNameText: "Jeffy Wan",
      profileDesignationText: "Co-Founder & CEO",
      paraText: "“We had an excellent experience with GammaSlots. They listened to our ideas and delivered the slot games just like we wanted. Their teams also made valuable suggestions that helped us make critical improvements in the games. I would recommend them to anyone seeking top-notch slot games.”",
    },
    {
      profileImageSrc: "/assets/stock-img/testimonial_img_02.webp",
      profileNameText: "Maria Janeson",
      profileDesignationText: "CEO",
      paraText: "“We wanted to launch our slot game quickly and the teams from GammaSlots helped us in multiple areas. Their teams are highly professional and they also shared their insights to help us understand our target customers better. We are very happy with the slot games they have delivered. We’ll be working with them again soon.”",
    },
  ],
};
